// extracted by mini-css-extract-plugin
export var img = "styles-module--img--iMWht";
export var text = "styles-module--text--qbxbj";
export var title = "styles-module--title--vcVBU";
export var usp = "styles-module--usp--prZ0W";